import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LogOut, User } from "lucide-react";
import PrismLogo from "@/components/PrismLogo";

export default function TopNav({ variant = "public" }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-slate-200/70"
      data-testid="top-nav"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
          <PrismLogo size={36} />
          <span className="font-display text-xl font-extrabold tracking-tight text-slate-900">
            Prismiq
          </span>
        </Link>

        {variant === "public" && (
          <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-slate-600">
            <a href="#features" className="hover:text-slate-900" data-testid="nav-features">Features</a>
            <a href="#roles" className="hover:text-slate-900" data-testid="nav-roles">For Roles</a>
            <a href="#pricing" className="hover:text-slate-900" data-testid="nav-pricing">Pricing</a>
          </nav>
        )}

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <NavLink
                to={user.role === "admin" ? "/admin" : user.role === "teacher" ? "/teacher" : "/dashboard"}
                className="btn-ghost text-sm"
                data-testid="nav-dashboard-link"
              >
                <User className="w-4 h-4" />
                {user.name.split(" ")[0]}
              </NavLink>
              <button className="btn-ghost text-sm" onClick={handleLogout} data-testid="logout-button">
                <LogOut className="w-4 h-4" /> Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn-ghost text-sm" data-testid="nav-login">
                Log in
              </Link>
              <Link to="/register" className="btn-primary text-sm" data-testid="nav-register">
                Get started
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
